import { NavigationService } from './../../../../core/services/navigation.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Entities } from 'src/app/core/models/globals';
import { take } from 'rxjs';
import { HeaderService } from '../../../../core/services/header.service';

@Component({
  selector: 'app-job-main-panel',
  templateUrl: './job-main-panel.component.html',
  styleUrls: ['./job-main-panel.component.scss'],
})
export class JobMainPanelComponent implements OnInit {

  lastRefreshedTime: Date; // time when data is loaded/refreshed
  depName: string = this.route.snapshot.params['deploymentName'] || this.route.parent.snapshot.params['deploymentName'];
  cloudType: string = this.route.snapshot.params['cloudType'] || this.route.parent.snapshot.params['cloudType'];
  storageNameLoaded: any = false;
  storageName: string;

  constructor(
    private route: ActivatedRoute,
    private navService: NavigationService,
    private router: Router,
    private depService: DeploymentService,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private headerService: HeaderService
  ) { }

  async ngOnInit(): Promise<any> {
    this.spinner.show('jobLoad');
    this.storageNameLoaded = await this.getStorageName();
    this.navService.sendCloud(this.cloudType)
    this.navService.subNavData(Entities.Jobs);
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  getStorageName() {
    return new Promise((resolve, reject) => {
      this.depService.getStorageNameForDeployment(this.depName)
        .pipe(take(1))
        .subscribe({
          next: (data: any) => {
            this.storageName = data?.storageName;
            this.storageService.sendActiveStorageName(this.storageName);
            this.spinner.hide('jobLoad');
            return resolve(true);
          },
          error: (err) => {
            this.spinner.hide('jobLoad');
            return resolve(false);
          }
        })
    })

  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
